import React, { useContext, useState, useEffect } from "react";
import { message, Modal } from "antd";
import { TailSpin } from "react-loader-spinner";
import { AppState } from "../App";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ethers } from "ethers";
import { useWeb3 } from "../contexts/Web3Context"; // Add this import


const Register = () => {
  const useAppState = useContext(AppState);
  const navigate = useNavigate(); 

  const {
    staticContract,
    walletAddress,
    isContractReady,
    isWalletConnected,
    getContract,
    provider,
    signer,
  } = useWeb3(); // Add Web3 context

  const [searchParams] = useSearchParams();
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [referrer, setReferrer] = useState("");

  useEffect(() => {
    async function getData() {
      try {
       /* console.log("Checking initialization status:", {
          isContractReady,
          isWalletConnected,
          walletAddress,
          contractAddress: staticContract?.address
        });*/
         // Wait for contract and wallet
        if (!isContractReady || !isWalletConnected) {
          //console.log("Still initializing...");
          return;
        }
         // If we don't have a wallet address, we can't proceed
        if (!walletAddress) {
          // console.log("No wallet address available");
          return;
        }
         // Instead of using useAppState.id, let's directly query the contract
        const userId = await staticContract.id(walletAddress);
        //console.log("User ID from contract:", userId.toString());
         // Get user info directly using the wallet address
        const user = await staticContract.userInfo(userId);
        //console.log("User info from contract:", user);
         const zeroAddr = "0x0000000000000000000000000000000000000000";
        
        // If the user's referrer is not the zero address, they're already registered
        if (user[0] !== zeroAddr) {
          //console.log("User already registered, redirecting to dashboard");
          //message.info("You are already registered");
          navigate("/dashboard");
        } else {
          //console.log("User not registered, showing modal");
          setModalOpen(true);
        }
       } catch (error) {
        console.error("Error in getData:", error);
        message.error("Failed to check registration status");
      }
    }
     getData();
  }, [isContractReady, isWalletConnected, walletAddress, staticContract, navigate]);

  useEffect(() => {
    let ref = searchParams.get("ref");
    if (ref !== null) {
      setReferrer(ref);
    } else {
      setReferrer("Invalid Referrer Link");
    }
  }, [searchParams]);

  const register = async () => {
    try {
      setLoading(true);
      if (!signer) {
        throw new Error("Signer not available");
      }
      // Verification step
      const registrationDetails = {
        baseAmount: useAppState.levels[1],
        percentage: useAppState.percent[1],
        totalAmount: (
          useAppState.levels[1] +
          (useAppState.levels[1] * useAppState.percent[1]) / 100
        ).toString(),
        referrer,
        walletAddress,
        contractAddress: staticContract.address,
      };
      //console.log("Registration verification:", registrationDetails);
      // Additional balance check
      const balance = await provider.getBalance(walletAddress);
      const requiredAmount = ethers.parseEther(registrationDetails.totalAmount);

      /*console.log("Balance check:", {
        userBalance: ethers.formatEther(balance),
        requiredAmount: registrationDetails.totalAmount,
        hasEnoughBalance: balance >= requiredAmount,
      });*/
      if (balance < requiredAmount) {
        throw new Error(
          `Insufficient balance. Need ${registrationDetails.totalAmount} BNB`
        );
      }
      //console.log("Starting registration transaction...");
      // Use contract with signer
      const contract = staticContract.connect(signer);
      const tx = await contract.register(referrer, walletAddress, {
        value: requiredAmount,
      });
      /*console.log("Transaction sent:", {
        hash: tx.hash,
        from: tx.from,
        to: tx.to,
        value: ethers.formatEther(tx.value),
      });*/

      const receipt = await tx.wait();
      /*console.log("Transaction confirmed:", {
        blockNumber: receipt.blockNumber,
        gasUsed: receipt.gasUsed.toString(),
        status: receipt.status,
      });*/

      message.success("Successfully Registered!");
      useAppState.setChange(useAppState.change + 1);
      setModalOpen(false);
      window.location.reload();
    } catch (error) {
      //console.error("Registration error:", error);
      message.error(error.reason || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  let OkText = loading ? (
    <TailSpin height={14} color="white" />
  ) : (
    <p>Register</p>
  );
  return (
    <div>
      <Modal
        title={
          <div className="text-2xl text-center font-semibold text-blue-600">
            Registration
          </div>
        }
        open={isModalOpen}
        closable={false}
        onOk={register}
        okText={OkText}
        cancelButtonProps={{ className: "hidden" }}
        centered
        width={600}
        className="registration-modal"
      >
        <div className="p-4 text-gray-700">
          <div className="flex w-full flex-col justify-center items-center space-y-4">
            <img
              src="/register.png"
              className="h-24 object-contain"
              alt="Register"
            />
            <div className="text-sm font-medium break-all text-center">
              <p className="mb-2">
                Referrer Id: {referrer === "17534" ? "default Refer" : referrer}
              </p>
              <p>
                Joining Fee:{" "}
                {useAppState.levels && useAppState.percent
                  ? `${
                      useAppState.levels[1] +
                      (useAppState.levels[1] * useAppState.percent[1]) / 100
                    } BNB`
                  : "Loading..."}
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default Register;
